import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Loader, ContainerControlSite, Content } from '@simplybenefits/sb-ui-library';
import { getRenewals, getAccount } from '../../../actions/accounts.js';
import RenewalCard from '../../../components/Cards/RenewalCard.js';
import Header from '../../../components/Header.js';
import AccountInformation from '../components/AccountInformation.js';

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const Renewals = ({ currentAccountMeta, dispatch, match }) => {
    const [ renewals, setRenewals ] = useState([]);

    useEffect(async () => {
        if (!currentAccountMeta) {
            await dispatch(getAccount(match.params.accountID));
        }

        const fetchedRenewals = await dispatch(getRenewals(match.params.accountID));
        setRenewals(fetchedRenewals);
    }, []);

    /**
     * Handles navigation to renewal page if allowed
     * @param renewal 
     */
    const _handleRenewalSelection = (renewal) => {
        if ([ 'In Renewal', 'Completed' ].includes(renewal.status)) {
            window.location.href = `/accounts/${ currentAccountMeta.accountID }/renewals/${ renewal.renewalID }`;
        }

        return null;
    };

    /**
     * Builds the breadcrumb navigation for the renewal page.
     * @returns {Array}
     */
    const _buildBreadcrumbs = () => [
        {
            title: 'Accounts',
            link: `/accounts`
        },
        {
            title: currentAccountMeta.company,
            link: `/accounts/${ match.params.accountID }`
        }
    ];

    if (!renewals || !currentAccountMeta) {
        return (
            <Loader/>
        );
    }

    return (
        <ContainerControlSite>
            <Header
                subHeader={ 'Renewals'}
                breadcrumbs={_buildBreadcrumbs()}
                selectedTitle="accounts"
            />

            <Content>
                <AccountInformation accountMeta={ currentAccountMeta } customStyle={{ marginBottom: 25 }}/>
                <>
                    {
                        renewals.length > 0 
                            ? (
                                renewals.map((renewal, index) => (
                                    <RenewalCard key={ renewal.renewalID } titleKey={ index + 1 } renewal={ renewal } onClick={ () => _handleRenewalSelection(renewal) }/>
                                )).reverse()
                            )
                            : null
                    } 
                </>
            </Content>
        </ContainerControlSite>    
    ); 
};

/**
 * @param state
 * @returns 
 */
const mapStateToProps = (state) => ({
    currentAccountMeta: state.accounts.currentAccount.meta
});

export default connect(mapStateToProps)(Renewals);